/**
 * Canonical status values shared by Projects and Tasks.
 * Keeping them centralized prevents drift between dropdowns.
 */
export const STATUS_OPTIONS = [
  "Not Started",
  "In Progress",
  "On Hold",
  "Suspended",
  "Completed",
];
